import React, {useEffect, useState} from 'react'
import {useTheme} from 'styled-components'
import {StyleProps, useWindowSize} from '@miro-site/core'
import Desktop from './components/Desktop'
import Mobile from './components/Mobile'

export type CategoryGroupItem = {
  title: string
  href: string
  slug: string
}

export type CategoryGroup = {
  title: string
  categories: CategoryGroupItem[]
}

export interface CategoryNavProps {
  rootGroups: CategoryGroup[]
  onMobilePopupClose?: () => void
  onCategoryOpen?: (category: CategoryGroupItem) => void
  isVisible?: boolean
  styles?: StyleProps
}

const CategoryNav = React.forwardRef<HTMLElement, CategoryNavProps>((props, ref) => {
  const [isMounted, setMounted] = useState<boolean>(false)

  const theme = useTheme()

  const windowSize = useWindowSize()

  const isMobileViewPort = windowSize.width && windowSize.width < theme.breakpoints.small

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!isMounted) {
    return null
  }

  if (isMobileViewPort) {
    return <Mobile ref={ref} {...props} />
  }

  return <Desktop ref={ref} {...props} />
})

CategoryNav.displayName = 'CategoryNav'

export default CategoryNav

export {default as Button} from './components/Button'
